import { render, staticRenderFns } from "./EditProgramJourneyAction.vue?vue&type=template&id=85807c4a"
import script from "./EditProgramJourneyAction.vue?vue&type=script&lang=js"
export * from "./EditProgramJourneyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports